export default "__VITE_ASSET__BORB34Xv__"